export const AUD_DEFAULT = { gain: 0, fade_in: 0, fade_out: 0, mute: false, pts: [] };
export const DB_MIN = -60, DB_MAX = 12;
const TOL = 0.02;

export const audOf = (c) => ({ ...AUD_DEFAULT, ...(c.aud || {}) });
export const dbToGain = (db) => (db <= DB_MIN ? 0 : Math.pow(10, db / 20));
export const dbToFrac = (db) => (DB_MAX - db) / (DB_MAX - DB_MIN);
export const fracToDb = (f) => +Math.max(DB_MIN, Math.min(DB_MAX, DB_MAX - f * (DB_MAX - DB_MIN))).toFixed(1);
const sortPts = (pts) => [...pts].sort((a, b) => a.t - b.t);

export function envDb(pts, t) {
  if (!pts.length) return 0;
  if (t <= pts[0].t) return pts[0].db;
  const j = pts.findIndex((p) => p.t > t);
  if (j < 0) return pts[pts.length - 1].db;
  const a = pts[j - 1], b = pts[j];
  return a.db + ((b.db - a.db) * (t - a.t)) / Math.max(1e-6, b.t - a.t);
}

export function audLevel(c, lt) {
  if (!c.aud) return 1;
  const a = audOf(c);
  if (a.mute) return 0;
  let g = dbToGain(Math.min(DB_MAX * 2, a.gain + envDb(a.pts, lt)));
  if (a.fade_in > 0) g *= Math.min(1, Math.max(0, lt / a.fade_in));
  if (a.fade_out > 0) g *= Math.min(1, Math.max(0, (c.len - lt) / a.fade_out));
  return g;
}

export const addPt = (aud, t, db) => ({ ...aud, pts: sortPts([...aud.pts.filter((p) => Math.abs(p.t - t) >= TOL), { t: +t.toFixed(3), db }]) });
export const movePt = (aud, i, t, db) => ({ ...aud, pts: sortPts(aud.pts.map((p, j) => (j === i ? { t: +t.toFixed(3), db } : p))) });
export const delPt = (aud, i) => ({ ...aud, pts: aud.pts.filter((_, j) => j !== i) });
export const shiftPts = (aud, dt) => ({ ...aud, pts: aud.pts.map((p) => ({ ...p, t: +(p.t + dt).toFixed(3) })).filter((p) => p.t >= -TOL).map((p) => ({ ...p, t: Math.max(0, p.t) })) });

export function sliceAud(aud, from, to, side) {
  const a = { ...AUD_DEFAULT, ...aud };
  const pts = a.pts.length
    ? [{ t: 0, db: +envDb(a.pts, from).toFixed(1) },
      ...a.pts.filter((p) => p.t > from + TOL && p.t < to - TOL).map((p) => ({ ...p, t: +(p.t - from).toFixed(3) })),
      { t: +(to - from).toFixed(3), db: +envDb(a.pts, to).toFixed(1) }]
    : [];
  return { ...a, pts, ...(side === "left" ? { fade_out: 0 } : { fade_in: 0 }) };
}
